import { create } from "zustand";

/**
 * Shared arrival snapshot of the website build kickoff, so useWebsiteAutoInit
 * and useServerPreviewDriver agree on one fact instead of each guessing from
 * `isStreaming`.
 *
 * `wasExistingRun`:
 *   - true  — the site was already initialized before this session (an existing
 *             /returning run: LangGraph has seen the thread, or a chat exists).
 *             Safe to build a preview on mount.
 *   - false — a fresh site whose first build run is still pending. The preview
 *             driver must NOT kick on mount (the template isn't forked yet, so a
 *             build would snapshot a package.json-less site and crash at `pnpm
 *             install`); the first preview arrives on the agent-done edge.
 *   - null  — not yet published. The driver treats this as "not yet" and waits.
 *
 * useWebsiteAutoInit is the authority — it already computes this to decide
 * whether to fire the kickoff — and publishes the arrival snapshot ONCE on mount
 * (never reactively: `chatId` flips truthy during the run, and republishing then
 * would let the mount-kick fire as the done-edge does).
 */
interface WebsiteKickoffStore {
  wasExistingRun: boolean | null;
  publishExistingRun: (value: boolean) => void;
}

export const useWebsiteKickoffStore = create<WebsiteKickoffStore>((set) => ({
  wasExistingRun: null,
  publishExistingRun: (value) => set({ wasExistingRun: value }),
}));
